<script>
  import { inertia, page } from '@inertiajs/svelte';
  import { menuOpenState } from '@/js/utils/stores.js';
  import responsive from '@/js/utils/responsive';

  import HeaderMenu from './menu/Index.svelte';
  import Burger from '$lib/Burger.svelte';

  // Toggle menu Bar.
  function toggleMenuState() {
    menuOpenState.update((open) => !open);
  }

  let innerWidth = 0;
  $: mobile = innerWidth <= responsive.s;

  $: siteLogo = $page.props.site_logo[$page.props.site_logo.default];
  $: mobileSiteLogo = $page.props.site_logo['dark'];
</script>

<svelte:window bind:innerWidth />

<header class="header">
  <HeaderMenu />

  <div class="container container--large">
    <div class="header__bar">
      <a href={$page.props.home_url} use:inertia>
        {#if mobile}
          <img
            src={mobileSiteLogo.src}
            width="140"
            height="35"
            alt={mobileSiteLogo.alt}
          />
        {:else}
          <img src={siteLogo.src} width="140" height="35" alt={siteLogo.alt} />
        {/if}
      </a>

      <Burger
        theme={mobile ? 'dark' : $page.props.header_theme}
        on:click={toggleMenuState}
      />
    </div>
  </div>
</header>

<style lang="scss">
  .header {
    position: absolute;

    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    padding: 3rem 0;

    @include resp-max('s') {
      border-bottom: 1px solid $light-border;
      padding: 1.5rem 0;
    }

    &__bar {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
